import { render, staticRenderFns } from "./PsdManagement.vue?vue&type=template&id=cc006e2e&scoped=true&"
import script from "./PsdManagement.vue?vue&type=script&lang=js&"
export * from "./PsdManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc006e2e",
  null
  
)

export default component.exports